import axios from 'axios'

const liveReportService = axios.create({
  baseURL: '/services/live-report/',
  headers: {
    'Content-Type': 'application/json'
  }
})

export default liveReportService
